import { combineReducers } from "redux";
import activeapicalls from "./activeapicalls/reducers";
import activeconnects from "./activeconnects/reducers";

const apicallsprogress = combineReducers({
  activeapicalls,
  activeconnects,
});

export default apicallsprogress;
